module.exports = __webpack_public_path__ + "3e96ed4afe38a571e717699d6af71fcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-dog-thank-you.png
// module id = 2032
// module chunks = 4